
export default {
    name: "IndexPage",
    data() {
        return {
            resultData: {},
            currentSystem: parseInt(JSON.parse(sessionStorage.getItem('currentSystem')).code)
            // employeeNo:0,
            // busCustomer:0,
            // recBLNumber:0,
            // sendBLNumber:0,
            // addBusCustomer:0,
            // addReBLNumber:0,
            // addSendBLNumber:0,
            // addConsumption:0,
            // appBLFileNumber:0,
            // recBLFileNumber:0,
            // scrappedBLFileNumber:0,
            // grandTotalConsumption:0,
            // waitApplyCustomer:0,
            // waitApplyScrapped:0,
            // waitApplyPrint:0,
            // waitRecConfirm:0
        }
    },
    mounted: function () {
    },
    created() {
        this.$axios.get('/api/admin/index').then(response => {
            this.resultData = response.data.resultData;
        }).catch(e => {
            console.log(e);
            this.$message({
                message: this.$t('common.message.operateFail'),
                type: 'error',
                center: true
            });
        });
    },
    methods: {
        toView(url, param){
            if(!param) {
                param = {
                    searchForm: {pageIndex: 1, pageNum: 1, page: 1,pageSize: 50},
                    row: {}
                };
            }else{
                param = {pageIndex: 1, pageNum: 1, page: 1, pageSize: 50, ...param};
            }
            // 设置参数
            this.$routerUtil.setParam(param);
            this.$router.push(url);
        },
    }
}
